module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon16.522ebefe.png";